import { EnumsInterface } from "@/interfaces/EnumsInterface";

const IncidentTime:EnumsInterface[] = [
    {id: 0, value: 0, label: "Within 72 hours"},
    {id: 1, value: 1, label: "More than 72 hours"},
]

export default IncidentTime